const mapSize = (size) => `models${size}`;
const makeName = (firstName, lastName) => (lastName ? `${firstName} ${lastName}` : firstName);

const cloudImg = (a) => a && a.replace('https://s3-eu-west-2.amazonaws.com/divastat1/', 'https://d163u5marr7nct.cloudfront.net/')

module.exports = {
  // baseurl: 'https://back.downthedrain.dk',
  // baseurl: 'http://django-env.eba-muttw99t.eu-west-2.elasticbeanstalk.com/website/',
  baseurl: 'https://backend.divamodels.com/website/',
  // baseurl: 'http://localhost:8000/website/',
  mapSize,
  cloudImg,
  makeName,
};
